import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import Spinner from "react-bootstrap/Spinner";
import {
  uploadTrackingCsv,
  trackingUploadStatus,
  trackingUploadResults,
  trackingUploadError,
  clearTrackingUpload
} from "../../../reducers/orders";

const ShippingAdmin = () => {
  const dispatch = useDispatch();
  const status = useSelector(trackingUploadStatus);
  const results = useSelector(trackingUploadResults);
  const error = useSelector(trackingUploadError);
  const [selectedFile, setSelectedFile] = useState(null);
  const [shippingDate, setShippingDate] = useState("");
  const hiddenFileInput = useRef(null);

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0] || null);
    dispatch(clearTrackingUpload());
  };

  const handleUpload = (event) => {
    event.preventDefault();
    if (!selectedFile) return;
    dispatch(uploadTrackingCsv({ file: selectedFile, shippingDate: shippingDate || undefined }));
  };

  const renderResultList = (items, variant) => {
    if (!items || !items.length) return null;
    return (
      <Alert variant={variant} className="mt-2">
        <ul className="mb-0">
          {items.map((item, idx) => (
            <li key={idx}>
              Order {item.orderId}
              {item.trackingNumber ? ` — ${item.trackingNumber}` : ""}
              {item.message ? `: ${item.message}` : ""}
            </li>
          ))}
        </ul>
      </Alert>
    );
  };

  return (
    <Container fluid className="mt-4">
      <h2 className="mb-3">Shipping Admin</h2>
      <p>
        Upload a tracking CSV to create shipments. The Tracking column can be
        filled once and will apply to the rows below it until another Tracking
        value is provided. Rows are matched by Order ID.
      </p>

      <Form onSubmit={handleUpload} className="mb-4" style={{ maxWidth: 480 }}>
        <Form.Group className="mb-3">
          <Form.Label>Shipping date (optional)</Form.Label>
          <Form.Control
            type="date"
            value={shippingDate}
            onChange={(e) => setShippingDate(e.target.value)}
          />
          <Form.Text muted>Defaults to today if left blank.</Form.Text>
        </Form.Group>

        <Button type="button" variant="outline-secondary" onClick={handleClick} className="me-2">
          Choose CSV File
        </Button>
        <input
          type="file"
          accept=".csv,text/csv"
          onChange={handleFileChange}
          ref={hiddenFileInput}
          style={{ display: "none" }}
        />
        <Button type="submit" disabled={!selectedFile || status === "loading"}>
          {status === "loading" ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Uploading…
            </>
          ) : (
            "Upload"
          )}
        </Button>
        <div className="mt-2">
          Selected file: {selectedFile ? selectedFile.name : "None"}
        </div>
      </Form>

      {error && <Alert variant="danger">{error}</Alert>}

      {results && (
        <div>
          <h4>Upload Results</h4>
          <p className="mb-1">
            Parsed {results.parsedCount} unique order/tracking pair(s).
            Created {results.created?.length || 0}, skipped {results.skipped?.length || 0},
            not found {results.notFound?.length || 0}, errors {results.errors?.length || 0}.
          </p>
          {renderResultList(results.created, "success")}
          {renderResultList(results.skipped, "secondary")}
          {renderResultList(results.notFound, "warning")}
          {renderResultList(results.errors, "danger")}
        </div>
      )}
    </Container>
  );
};

export default ShippingAdmin;
